import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ContactSection from "../../components/ContactSection";

const ContactPage = (props) => {
  return (
    <Fragment>
      <main className="page_content about-page">
        <PageTitle pageTitle={"Contact Us"} />
        <ContactSection />
      </main>
      <Scrollbar />
    </Fragment>
  );
};

export default ContactPage;
